export default __webpack_public_path__ + "static/media/tab-slider-1.55862a23.png";